import { z } from "zod";

export const findPasswordResponseSchema = z.object({
  isSelfCert: z.enum(["Y", "N"]),
  emailAddr: z.string().optional(),
  q: z.string().optional(),
  pccafeAccount: z.string(),
});

export type FindPasswordResponseType = z.infer<typeof findPasswordResponseSchema>;
